export const declines = (number, titles, pre = false, post = false) => {
	const cases = [2, 0, 1, 1, 1, 2];
	return `${pre ? `${number} ` : ''}${titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]}${post ? ` ${number}` : ''}`;
};